<template>
  <!--
    /wyniki-wyszukiwania/ shows either the result list or a single auction,
    exactly as the embedded app used to: the iframe loaded #/search and
    redirected itself to #/auction/<id> when a lot number was present. Now both
    render in place and the page URL stays /wyniki-wyszukiwania/?lot_number=<id>.
  -->
  <AuctionView v-if="lotNumber" :key="lotNumber" :auction-id="lotNumber" />
  <SearchView v-else />
</template>

<script>
import SearchView from '@/views/SearchView.vue'
import AuctionView from '@/views/AuctionView.vue'

export default {
  name: 'SearchSlot',
  components: { SearchView, AuctionView },

  computed: {
    lotNumber() {
      const value = this.$route.query.lot_number
      return value ? String(value) : null
    },
  },
}
</script>
